import { useState } from "react";
import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import OrderAPIDataSourceImpl from "../../Data/DataSource/API/OrderAPIDataSource";
import { OrderRepositoryImpl } from "../../Data/Repository/ProductRepositoryImpl";
import { Orders } from "../../Domain/Model/Orders";
import { GetOrderById } from "../../Domain/UseCase/GetOrderById";
import { GetOrders } from "../../Domain/UseCase/GetOrders";
import { UpdateOrderStatus } from "../../Domain/UseCase/UpdateOrderStatus";
import { UpdateDeliveryDate } from "../../Domain/UseCase/UpdateDeliveryDate";
import { AddingInvoice } from "../../Domain/UseCase/AddingInvoice";
import { GetOrderTicketById } from "../../Domain/UseCase/GetOrderTicketById";

export default function ProductViewModel() {

  const [orders, setOrders] = useState<Orders[]>([]);

  const productDataSourceImpl = new OrderAPIDataSourceImpl();
  const productRepositoryImpl = new OrderRepositoryImpl(productDataSourceImpl);

  const getOrdersUseCase = new GetOrders(productRepositoryImpl);
  const getOrderByIdUseCase = new GetOrderById(productRepositoryImpl);

  const updateOrderStatusUseCase = new UpdateOrderStatus(productRepositoryImpl);

  const updateDeliveryDateUseCase = new UpdateDeliveryDate(productRepositoryImpl);

  const addingInvoiceUseCase = new AddingInvoice(productRepositoryImpl);

  const getOrderTicketByIdUseCase = new GetOrderTicketById(productRepositoryImpl);

  async function getOrders(page: number, size: number, orderCode: string, sortOrder: string, orderStatus: any, paymentMethod: any, deliveryMethod: any, fromDate: string, toDate: string, sortColumn: string): Promise<{ items: Orders[]; totalCount: number }> {
    try {
      const result: PaginationResult<Orders> = await getOrdersUseCase.invoke(page, size, orderCode, sortOrder, orderStatus, paymentMethod, deliveryMethod, fromDate, toDate, sortColumn);
  
      await setOrders(result.items); // Si quieres mantenerlo en el ViewModel
      
  
      return {
        items: result.items,
        totalCount: result.totalCount, // usar totalCount según tu interfaz
      };
    } catch (error) {
      console.error("Error al obtener productos:", error);
      return { items: [], totalCount: 0 };
    }
  }

  async function getProductById(orderId: number) {
    try {
      const productById = await getOrderByIdUseCase.invoke(orderId);
      if (productById) {
        return productById;
      }
      
    } catch (e) {
      
      if (e instanceof Error) {
        console.log(e.message);
      }
      return Error;
    }
  }

  async function updateOrderStatus(data: any){
    try {
      const response = await updateOrderStatusUseCase.invoke(data);
      if (response) {
        
        return response;
      }
      //_resetValue();
    } catch (e) {
      //_resetValue();
      if (e instanceof Error) {
        console.log(e.message);
      }
      return Error;
    }
  }
  
  async function updateDeliveryDate(data: any){
    try {
      const response = await updateDeliveryDateUseCase.invoke(data);
      if (response) {
        
        return response;
      }
      //_resetValue();
    } catch (e) {
      //_resetValue();
      if (e instanceof Error) {
        console.log(e.message);
      }
      return Error;
    }
  }

  async function addingInvoice(data: any){
     try {
      const response = await addingInvoiceUseCase.invoke(data);
      if (response) {
        
        return response;
      }
      //_resetValue();
    } catch (e) {
      //_resetValue();
      if (e instanceof Error) {
        console.log(e.message);
      }
      return Error;
    }
  }

  async function getOrderTicketById(id: number){
     try {
      const response = await getOrderTicketByIdUseCase.invoke(id);
      if (response) {
        
        return response;
      }
      //_resetValue();
    } catch (e) {
      //_resetValue();
      if (e instanceof Error) {
        console.log(e.message);
      }
      return Error;
    }
  }

  return {
    getOrders,
    orders,
    getProductById,
    updateOrderStatus,
    updateDeliveryDate,
    addingInvoice,
    getOrderTicketById
  };
}